import { defineMessages } from 'react-intl';

export const meddeviceComplianceNotificationMessages = defineMessages({
  mfaSetupTitle: {
    defaultMessage: 'Set up multi-factor authentication',
    id: 'W4Dl+veMXC',
    description:
      'Pinned notification title prompting the user to enable MFA in account settings',
  },
  inactivityLogoutTitle: {
    defaultMessage: 'Turn on inactivity timeout',
    id: 'FOwEtVtC9s',
    description:
      'Pinned notification title prompting the user to enable inactivity timeout',
  },
});
